import { FC, Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'

const PrivateRoutes = () => {
  const BaseDefinitionPage = lazy(() => import('../modules/base-definitions/BaseDefinitionPage'))
  const UserDefinitionPage = lazy(() => import('../modules/user-definitions/UserDefinitionPage'))
  const GraduationSystemPage = lazy(
    () => import('../modules/graduation-system/GraduationSystemPage')
  )
  const SystemDefinitionPage = lazy(
    () => import('../modules/system-definitions/SystemDefinitionPage')
  )
  const NewsSystemPage = lazy(() => import('../modules/news/NewsSystemPage'))
  const CompanyOwnersPanelPage = lazy(
    () => import('../modules/areas/company-owners/CompanyOwnersPanelPage')
  )
  const SendEmailSystemPage = lazy(() => import('../modules/send-email-system/SendEmailSystemPage'))
  const CompanyJobSystemPage = lazy(() => import('../modules/company-and-job/CompanyJobSystemPage'))
  const GraduatesPanelPage = lazy(() => import('../modules/areas/graduates/GraduatesPanelPage'))
  const AdminPanelPage = lazy(() => import('../modules/areas/admin/AdminPanelPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))

  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />

        {/* Lazy Modules */}
        <Route
          path='/graduation-system/*'
          element={
            <SuspensedView>
              <GraduationSystemPage />
            </SuspensedView>
          }
        />

        <Route
          path='/graduation-panel/*'
          element={
            <SuspensedView>
              <GraduatesPanelPage />
            </SuspensedView>
          }
        />

        <Route
          path='/company-panel/*'
          element={
            <SuspensedView>
              <CompanyOwnersPanelPage />
            </SuspensedView>
          }
        />

        <Route
          path='/admin-panel/*'
          element={
            <SuspensedView>
              <AdminPanelPage />
            </SuspensedView>
          }
        />

        <Route
          path='/send-email-system/*'
          element={
            <SuspensedView>
              <SendEmailSystemPage />
            </SuspensedView>
          }
        />

        <Route
          path='/news-module/*'
          element={
            <SuspensedView>
              <NewsSystemPage />
            </SuspensedView>
          }
        />
        <Route
          path='/company-and-jobs/*'
          element={
            <SuspensedView>
              <CompanyJobSystemPage />
            </SuspensedView>
          }
        />
        <Route
          path='/user-definitions/*'
          element={
            <SuspensedView>
              <UserDefinitionPage />
            </SuspensedView>
          }
        />
        <Route
          path='/system-definitions/*'
          element={
            <SuspensedView>
              <SystemDefinitionPage />
            </SuspensedView>
          }
        />
        <Route
          path='/base-definitions/*'
          element={
            <SuspensedView>
              <BaseDefinitionPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='/crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        /> */}
        <Route
          path='/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        /> */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
